(function () {
  'use strict';

  if (window.MCubeWishlistProjects) return;

  var core = window.MCubeCore;
  if (!core) return;

  var productCache = core.createSessionProductCache();
  var productQueue = [];
  var productRequests = 0;
  var PRODUCT_CONCURRENCY = 4;
  var nativeCardCache = new Map();
  var nativeCardQueue = [];
  var nativeCardRequests = 0;
  var NATIVE_CARD_CONCURRENCY = 3;
  var MAX_SHARE_LENGTH = 5200;
  var WHATSAPP_RECIPIENT = '919967434881';

  function wishlistStore() {
    return window.WishlistStore || window.MCubeWishlist || null;
  }

  function projectStore() {
    return window.ProjectStore || window.MCubeProjects || null;
  }

  function escapeHtml(value) {
    return String(value === null || value === undefined ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function rootUrl() {
    var root = window.theme && window.theme.routes && window.theme.routes.root;
    if (!root && window.Shopify && window.Shopify.routes) root = window.Shopify.routes.root;
    root = root || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function referenceKey(reference) {
    return core.getReferenceKey(core.createReference(reference));
  }

  function referenceType(reference) {
    return core.getReferenceType(reference);
  }

  function itemReference(item) {
    return core.createReference(item && (item.reference || item.product || item));
  }

  function findVariant(product, reference) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var wanted = String(reference.variantId || '');
    var selected = variants.find(function (variant) {
      return String(variant.id) === wanted;
    });

    return selected || variants.find(function (variant) { return variant.available; }) || variants[0] || null;
  }

  function imageSource(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.src || value.url || '';
  }

  function absoluteUrl(path) {
    try {
      return new URL(path, window.location.origin).href;
    } catch (error) {
      return path;
    }
  }

  function normalizeProduct(product, reference) {
    var variant = findVariant(product, reference);
    var variantImage = variant && (variant.featured_image || variant.featured_media);
    var image = imageSource(variantImage) || imageSource(product.featured_image) || imageSource(product.images && product.images[0]);
    var variantId = reference.variantId || (variant && variant.id) || '';
    var url = rootUrl() + 'products/' + encodeURIComponent(reference.handle);
    if (variantId) url += '?variant=' + encodeURIComponent(variantId);

    return {
      missing: false,
      handle: reference.handle,
      title: product.title || reference.handle,
      url: absoluteUrl(url),
      image: image,
      code: reference.sku || (variant && variant.sku) || reference.handle.replace(/-/g, ' '),
      price: variant ? variant.price : product.price,
      variantId: String(variantId || ''),
      reference: reference
    };
  }

  function missingProduct(reference) {
    return {
      missing: true,
      handle: reference.handle,
      title: 'Material unavailable',
      url: absoluteUrl(rootUrl() + 'products/' + encodeURIComponent(reference.handle)),
      image: '',
      code: reference.sku || reference.handle.replace(/-/g, ' '),
      price: null,
      variantId: reference.variantId || '',
      reference: reference
    };
  }

  function normalizeScene(input) {
    var reference = core.createSceneReference(input);
    if (!reference) return null;
    return {
      missing: false,
      type: 'scene',
      handle: reference.handle,
      title: reference.title,
      url: absoluteUrl(reference.url || rootUrl() + 'pages/inspiration-center'),
      image: reference.image,
      code: '',
      room: reference.room,
      style: reference.style,
      materials: reference.materials,
      reference: reference
    };
  }

  function runProductQueue() {
    while (productRequests < PRODUCT_CONCURRENCY && productQueue.length) {
      var task = productQueue.shift();
      productRequests += 1;
      task.run().then(task.resolve, task.reject).finally(function () {
        productRequests -= 1;
        runProductQueue();
      });
    }
  }

  function queueProductRequest(run) {
    return new Promise(function (resolve, reject) {
      productQueue.push({ run: run, resolve: resolve, reject: reject });
      runProductQueue();
    });
  }

  function fetchProduct(input) {
    var reference = core.createProductReference(input);
    if (!reference) return Promise.resolve(null);
    var cached = productCache.get(reference.handle);
    if (cached) {
      return Promise.resolve(cached).then(function (entry) {
        return entry && entry.__mcubeRaw ? normalizeProduct(entry.__mcubeRaw, reference) : missingProduct(reference);
      });
    }

    var request = queueProductRequest(function () {
      return fetch(rootUrl() + 'products/' + encodeURIComponent(reference.handle) + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product request failed');
          return response.json();
        })
        .then(function (product) {
          return { __mcubeRaw: product };
        })
        .catch(function () {
          return { __mcubeMissing: true };
        });
      });

    productCache.set(reference.handle, request);
    return request.then(function (entry) {
      productCache.set(reference.handle, entry);
      return entry.__mcubeRaw ? normalizeProduct(entry.__mcubeRaw, reference) : missingProduct(reference);
    });
  }

  function resolveReference(input) {
    var reference = core.createReference(input);
    if (!reference) return Promise.resolve(null);
    return reference.type === 'scene' ? Promise.resolve(normalizeScene(reference)) : fetchProduct(reference);
  }

  function resolveReferences(references) {
    return Promise.all((references || []).map(resolveReference)).then(function (items) {
      return items.filter(Boolean);
    });
  }

  function fetchProducts(references) {
    return Promise.all((references || []).map(fetchProduct)).then(function (products) {
      return products.filter(Boolean);
    });
  }

  function runNativeCardQueue() {
    while (nativeCardRequests < NATIVE_CARD_CONCURRENCY && nativeCardQueue.length) {
      var task = nativeCardQueue.shift();
      nativeCardRequests += 1;
      task.run().then(task.resolve, task.reject).finally(function () {
        nativeCardRequests -= 1;
        runNativeCardQueue();
      });
    }
  }

  function queueNativeCardRequest(run) {
    return new Promise(function (resolve, reject) {
      nativeCardQueue.push({ run: run, resolve: resolve, reject: reject });
      runNativeCardQueue();
    });
  }

  function fetchNativeCard(input) {
    var reference = core.createProductReference(input);
    if (!reference) return Promise.resolve('');
    var cacheKey = reference.handle + ':' + (reference.variantId || 'default');
    if (nativeCardCache.has(cacheKey)) return nativeCardCache.get(cacheKey);

    var request = queueNativeCardRequest(function () {
      var url = rootUrl() + 'products/' + encodeURIComponent(reference.handle) + '?section_id=api-product-grid-item';
      if (reference.variantId) url += '&variant=' + encodeURIComponent(reference.variantId);
      return fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Native product card request failed');
          return response.text();
        })
        .then(function (html) {
          var documentFragment = new DOMParser().parseFromString(html, 'text/html');
          var content = documentFragment.querySelector('[data-api-content]');
          if (!content) throw new Error('Native product card content missing');
          return content.innerHTML.trim();
        })
        .catch(function () { return ''; });
    });

    nativeCardCache.set(cacheKey, request);
    return request;
  }

  function fetchWishlistCards(references) {
    return Promise.all((references || []).map(function (reference) {
      if (referenceType(reference) === 'scene') {
        return Promise.resolve({ html: '', product: normalizeScene(reference), reference: reference });
      }
      return Promise.all([fetchNativeCard(reference), fetchProduct(reference)]).then(function (values) {
        return { html: values[0], product: values[1], reference: reference };
      });
    }));
  }

  function padCount(value) {
    return String(Number(value) || 0).padStart(2, '0');
  }

  function formatDate(timestamp) {
    try {
      return new Intl.DateTimeFormat(undefined, { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(timestamp));
    } catch (error) {
      return '';
    }
  }

  function materialLine(product, index, item) {
    var lines = [String(index + 1).padStart(2, '0') + '. ' + product.title];
    if (product.code) lines.push('Code: ' + product.code);
    if (item && item.requirement) lines.push('Requirement: ' + item.requirement);
    if (item && item.note) lines.push('Note: ' + item.note);
    lines.push(product.url);
    return lines.join('\n');
  }

  function sceneLine(scene, index, item) {
    var lines = [String(index + 1).padStart(2, '0') + '. ' + scene.title];
    if (scene.room) lines.push('Room type: ' + scene.room);
    if (scene.style) lines.push('Style: ' + scene.style);
    if (scene.materials) lines.push('Materials: ' + scene.materials);
    if (item && item.note) lines.push('Note: ' + item.note);
    if (scene.url) lines.push(scene.url);
    return lines.join('\n');
  }

  function globalNotice(message) {
    var toast = document.querySelector('[data-mcube-global-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mcube-toast';
      toast.dataset.mcubeGlobalToast = '';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.hidden = true;
      document.body.appendChild(toast);
    }
    announce(toast, message);
  }

  function limitMessage(header, blocks, footer, noun) {
    var kept = [];
    var omitted = 0;
    noun = noun || 'material';

    blocks.forEach(function (block) {
      var next = [header].concat(kept, [block, footer || '']).filter(Boolean).join('\n\n');
      if (next.length <= MAX_SHARE_LENGTH) kept.push(block);
      else omitted += 1;
    });

    if (omitted) {
      kept.push('+' + omitted + ' more ' + noun + (omitted === 1 ? '' : 's') + ' saved in the browser.');
      globalNotice('The WhatsApp message was shortened by ' + omitted + ' ' + noun + (omitted === 1 ? '' : 's') + ' to keep the share link reliable.');
    }
    return [header].concat(kept, [footer || '']).filter(Boolean).join('\n\n');
  }

  function buildWishlistMessage(references, heading) {
    return resolveReferences(references).then(function (items) {
      var title = heading || 'M Cube Spaces Wishlist';
      var header = title;
      var products = items.filter(function (item) { return item.type !== 'scene'; });
      var scenes = items.filter(function (item) { return item.type === 'scene'; });
      if (!scenes.length) {
        var productBlocks = products.map(function (product, index) { return materialLine(product, index); });
        return limitMessage(header, productBlocks, 'Total materials: ' + products.length + '\n\nShared from M Cube Spaces');
      }
      var blocks = [];
      if (products.length) blocks.push('Materials\n' + products.map(function (product, index) { return materialLine(product, index); }).join('\n\n'));
      blocks.push('Inspiration Scenes\n' + scenes.map(function (scene, index) { return sceneLine(scene, index); }).join('\n\n'));
      var footer = 'Total materials: ' + products.length + '\nTotal inspiration scenes: ' + scenes.length + '\n\nShared from M Cube Spaces';
      return limitMessage(header, blocks, footer, 'item');
    });
  }

  function projectItems(project) {
    var items = [];
    (project.unassignedItems || []).forEach(function (item) {
      items.push({ item: item, sectionName: 'Unassigned' });
    });
    (project.sections || []).forEach(function (section) {
      (section.items || []).forEach(function (item) {
        items.push({ item: item, sectionName: section.name });
      });
    });
    return items;
  }

  function projectCounts(project) {
    var entries = projectItems(project);
    var scenes = entries.filter(function (entry) { return referenceType(itemReference(entry.item)) === 'scene'; }).length;
    return { total: entries.length, materials: entries.length - scenes, scenes: scenes };
  }

  function buildProjectMessage(project) {
    var groups = (project.sections || []).map(function (section) {
      return { name: section.name, items: section.items || [] };
    });
    if ((project.unassignedItems || []).length) {
      groups.push({ name: 'Unassigned', items: project.unassignedItems });
    }
    var allItems = groups.reduce(function (items, group) { return items.concat(group.items); }, []);
    var materialTotal = allItems.filter(function (item) { return referenceType(itemReference(item)) === 'product'; }).length;
    var sceneTotal = allItems.length - materialTotal;
    return Promise.all(groups.map(function (group) {
      return Promise.all(group.items.map(function (item) { return resolveReference(itemReference(item)); })).then(function (resources) {
        var materialLines = [];
        var sceneLines = [];
        resources.forEach(function (resource, index) {
          if (!resource) return;
          if (resource.type === 'scene') sceneLines.push(sceneLine(resource, sceneLines.length, group.items[index]));
          else materialLines.push(materialLine(resource, materialLines.length, group.items[index]));
        });
        var sections = [group.name];
        if (materialLines.length) sections.push('Materials\n' + materialLines.join('\n\n'));
        if (sceneLines.length) sections.push('Inspiration References - Not Priced Line Items\n' + sceneLines.join('\n\n'));
        return sections.join('\n\n');
      });
    })).then(function (blocks) {
      var quoteMode = materialTotal > 0;
      var header = quoteMode
        ? 'M Cube Spaces Quote Request\n\nI would like to request pricing and availability for the following project material schedule.\n\nProject: ' + project.name
        : 'M Cube Spaces Project Inspiration\n\nI would like to share the following inspiration references for this project.\n\nProject: ' + project.name;
      var footer = 'Total materials: ' + materialTotal + '\nTotal inspiration scenes: ' + sceneTotal;
      footer += quoteMode
        ? '\n\nPlease share pricing, availability, lead times, minimum order quantities (MOQ), and delivery details. The inspiration references are included as visual context only. Please contact me if any quantities or specifications need clarification.'
        : '\n\nThese scenes are shared as visual direction. Please contact me to discuss suitable materials, finishes, and specifications.';
      footer += '\n\nSubmitted from M Cube Spaces';
      return limitMessage(header, blocks.filter(Boolean), footer, 'project item');
    });
  }

  function openWhatsApp(messagePromise) {
    var popup = window.open('about:blank', '_blank');
    if (popup) popup.opener = null;

    return Promise.resolve(messagePromise)
      .then(function (message) {
        var shareUrl = 'https://wa.me/' + WHATSAPP_RECIPIENT + '?text=' + encodeURIComponent(message);
        if (popup) popup.location.replace(shareUrl);
        else window.location.href = shareUrl;
      })
      .catch(function () {
        if (popup) popup.close();
        globalNotice('WhatsApp sharing could not be prepared. Please try again.');
      });
  }

  function showDialog(dialog, trigger) {
    if (!dialog) return;
    dialog.__mcubeTrigger = trigger || document.activeElement;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    var focusTarget = dialog.querySelector('input:not([type="hidden"]), button, select, textarea');
    if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 0);
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    if (dialog.__mcubeTrigger && typeof dialog.__mcubeTrigger.focus === 'function') dialog.__mcubeTrigger.focus();
  }

  function bindDialogClosers(root) {
    root.querySelectorAll('[data-mcube-dialog-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeDialog(button.closest('dialog')); });
    });
    root.querySelectorAll('dialog').forEach(function (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog(dialog);
      });
    });
  }

  function announce(element, message) {
    if (!element) return;
    element.textContent = message;
    element.hidden = false;
    window.clearTimeout(element.__mcubeTimer);
    element.__mcubeTimer = window.setTimeout(function () { element.hidden = true; }, 3200);
  }

  function emptyImageMarkup(label) {
    return '<span>' + escapeHtml(label || 'No image') + '</span>';
  }

  function getReferenceFromElement(element) {
    if (!element) return null;
    if (!element.dataset.resourceType && typeof element.closest === 'function') {
      element = element.closest('[data-mcube-scene-reference], [data-resource-type]') || element;
    }
    if (element.dataset.resourceType === 'scene') {
      var sceneUrl = element.dataset.sceneUrl || '';
      var sceneHandle = element.dataset.sceneHandle || '';
      if (!sceneHandle && sceneUrl) {
        sceneHandle = sceneUrl.split('?')[0].split('/').filter(Boolean).pop() || '';
      }
      return core.createSceneReference({
        type: 'scene',
        handle: sceneHandle,
        title: element.dataset.sceneTitle,
        url: element.dataset.sceneUrl,
        image: element.dataset.sceneImage,
        room: element.dataset.sceneRoom,
        style: element.dataset.sceneStyle,
        materials: element.dataset.sceneMaterials
      });
    }
    return core.createProductReference({
      handle: element.dataset.productHandle,
      productId: element.dataset.productId,
      variantId: element.dataset.variantId,
      sku: element.dataset.productSku
    });
  }

  class MCubeWishlistButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-mcube-wishlist-toggle]');
      if (!this.button || this.__mcubeReady) return;
      this.__mcubeReady = true;
      this.onClick = this.handleClick.bind(this);
      this.onVariant = this.handleVariant.bind(this);
      this.button.addEventListener('click', this.onClick);
      this.bindStore();

      if (this.dataset.context === 'product') {
        document.addEventListener('theme:variant:change', this.onVariant);
        document.addEventListener('variant:change', this.onVariant);
        document.addEventListener('variant-change', this.onVariant);
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.button) this.button.removeEventListener('click', this.onClick);
      document.removeEventListener('theme:variant:change', this.onVariant);
      document.removeEventListener('variant:change', this.onVariant);
      document.removeEventListener('variant-change', this.onVariant);
    }

    bindStore() {
      var store = wishlistStore();
      if (!store) {
        this.__mcubeRetry = window.setTimeout(this.bindStore.bind(this), 60);
        return;
      }
      this.unsubscribe = store.subscribe(this.render.bind(this));
      var reference = this.reference();
      if (reference && reference.type === 'scene' && store.has(reference) && typeof store.refresh === 'function') {
        store.refresh(reference);
      }
      var projects = projectStore();
      if (reference && reference.type === 'scene' && projects && typeof projects.refreshReference === 'function') {
        projects.refreshReference(reference);
      }
      this.render();
    }

    reference() {
      return getReferenceFromElement(this);
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      var store = wishlistStore();
      var reference = this.reference();
      if (store && reference) store.toggle(reference);
      else globalNotice('This inspiration scene could not be saved. Please refresh the page and try again.');
    }

    handleVariant(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || !variant.id) return;
      if (variant.product_id && String(variant.product_id) !== String(this.dataset.productId)) return;
      this.dataset.variantId = variant.id;
      this.dataset.productSku = variant.sku || '';
      this.render();
    }

    render() {
      var store = wishlistStore();
      var reference = this.reference();
      if (!store || !reference || !this.button) return;
      var active = store.has(reference);
      var isScene = reference.type === 'scene';
      var title = isScene ? (this.dataset.sceneTitle || 'this inspiration') : (this.dataset.productTitle || 'this material');
      this.classList.toggle('is-active', active);
      this.button.setAttribute('aria-pressed', String(active));
      this.button.setAttribute('aria-label', (active ? 'Remove ' : 'Save ') + title + (active ? ' from Wishlist' : ' to Wishlist'));
      var label = this.querySelector('[data-mcube-wishlist-label]');
      if (label) label.textContent = isScene ? (active ? 'Inspiration Saved' : 'Save Inspiration') : (active ? (this.dataset.context === 'product' ? 'Wishlisted' : 'Saved') : 'Add to Wishlist');
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.mcube-scene-save [data-mcube-wishlist-toggle]');
    if (!trigger) return;
    var control = trigger.closest('mcube-wishlist-button');
    if (control && control.__mcubeReady) return;
    event.preventDefault();
    event.stopPropagation();
    var store = wishlistStore();
    var reference = getReferenceFromElement(control || trigger);
    if (store && reference) store.toggle(reference);
    else globalNotice('This inspiration scene could not be saved. Please refresh the page and try again.');
  });

  class MCubeHeaderWishlist extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-mcube-wishlist-drawer-open]');
      this.countElement = this.querySelector('[data-mcube-wishlist-count]');
      if (!this.button || this.__mcubeReady) return;
      this.__mcubeReady = true;
      this.button.addEventListener('click', function (event) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('mcube:wishlist-drawer:open', { detail: { trigger: event.currentTarget } }));
      });
      this.bindStore();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    bindStore() {
      var store = wishlistStore();
      if (!store) {
        window.setTimeout(this.bindStore.bind(this), 60);
        return;
      }
      this.unsubscribe = store.subscribe(this.render.bind(this));
      this.render();
    }

    render() {
      var store = wishlistStore();
      if (!store || !this.button) return;
      var count = store.count();
      if (this.countElement) this.countElement.textContent = count > 99 ? '99+' : String(count);
      this.classList.toggle('has-items', count > 0);
      this.button.setAttribute('aria-label', 'Open Wishlist, ' + count + ' saved item' + (count === 1 ? '' : 's'));
    }
  }

  class MCubeWishlistDrawer extends HTMLElement {
    connectedCallback() {
      if (this.__mcubeReady) return;
      this.__mcubeReady = true;
      this.panel = this.querySelector('[data-mcube-drawer-panel]');
      this.listView = this.querySelector('[data-mcube-drawer-list-view]');
      this.projectView = this.querySelector('[data-mcube-drawer-project-view]');
      this.itemsElement = this.querySelector('[data-mcube-drawer-items]');
      this.statusElement = this.querySelector('[data-mcube-drawer-status]');
      this.footer = this.querySelector('[data-mcube-drawer-footer]');
      this.wishlistActions = this.querySelector('[data-mcube-drawer-wishlist-actions]');
      this.regularActions = this.querySelector('[data-mcube-drawer-regular-actions]');
      this.selectionActions = this.querySelector('[data-mcube-drawer-selection-actions]');
      this.selectionCount = this.querySelector('[data-mcube-drawer-selection-count]');
      this.projectOpenButton = this.querySelector('[data-mcube-drawer-project-open]');
      this.projectActions = this.querySelector('[data-mcube-drawer-project-actions]');
      this.projectForm = this.querySelector('[data-mcube-drawer-project-form]');
      this.projectSubmit = this.querySelector('[data-mcube-drawer-project-submit]');
      this.projectOptions = this.querySelector('[data-mcube-drawer-project-options]');
      this.newProjectField = this.querySelector('[data-mcube-drawer-new-project-field]');
      this.projectTitle = this.querySelector('.mcube-drawer-project__head h3');
      this.projectCount = this.querySelector('[data-mcube-drawer-project-count]');
      this.projectPlural = this.querySelector('[data-mcube-drawer-project-plural]');
      this.countElement = this.querySelector('[data-mcube-drawer-count]');
      this.selected = new Set();
      this.projectPickerOpen = false;
      this.onOpen = this.open.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onClick = this.handleAction.bind(this);
      this.onChange = this.handleChange.bind(this);
      document.addEventListener('mcube:wishlist-drawer:open', this.onOpen);
      this.querySelectorAll('[data-mcube-drawer-close]').forEach(function (button) {
        button.addEventListener('click', this.close.bind(this));
      }, this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      if (this.projectForm) this.projectForm.addEventListener('submit', this.addToProject.bind(this));
      this.bindWishlistStore();
      this.bindProjectStore();
    }

    disconnectedCallback() {
      document.removeEventListener('mcube:wishlist-drawer:open', this.onOpen);
      document.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      window.clearTimeout(this.__mcubeWishlistRetry);
      window.clearTimeout(this.__mcubeProjectRetry);
      if (this.wishlistUnsubscribe) this.wishlistUnsubscribe();
      if (this.projectUnsubscribe) this.projectUnsubscribe();
    }

    bindWishlistStore() {
      var store = wishlistStore();
      if (!store) {
        this.__mcubeWishlistRetry = window.setTimeout(this.bindWishlistStore.bind(this), 60);
        return;
      }
      this.wishlistUnsubscribe = store.subscribe(this.render.bind(this));
      this.render();
    }

    bindProjectStore() {
      var store = projectStore();
      if (!store) {
        this.__mcubeProjectRetry = window.setTimeout(this.bindProjectStore.bind(this), 60);
        return;
      }
      this.projectUnsubscribe = store.subscribe(function () {
        this.syncProjectAction();
        if (this.projectPickerOpen) this.populateProjectOptions();
      }.bind(this));
      this.syncProjectAction();
    }

    open(event) {
      this.returnFocus = event && event.detail && event.detail.trigger ? event.detail.trigger : document.activeElement;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.querySelectorAll('[data-mcube-wishlist-drawer-open]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      });
      document.addEventListener('keydown', this.onKeydown);
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: this }));
      if (window.theme && window.theme.a11y && this.panel) {
        window.theme.a11y.trapFocus(this.panel, { elementToFocus: this.panel.querySelector('[data-mcube-drawer-close]') });
      } else if (this.panel) {
        this.panel.focus();
      }
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      if (this.projectPickerOpen) this.closeProjectPicker(false);
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.querySelectorAll('[data-mcube-wishlist-drawer-open]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      document.removeEventListener('keydown', this.onKeydown);
      if (window.theme && window.theme.a11y) window.theme.a11y.removeTrapFocus();
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('mcube:wishlist-drawer:close', { bubbles: true, detail: { target: this } }));
      if (this.returnFocus && typeof this.returnFocus.focus === 'function') this.returnFocus.focus();
    }

    handleKeydown(event) {
      if (event.key !== 'Escape') return;
      if (this.projectPickerOpen) {
        event.preventDefault();
        this.closeProjectPicker(true);
        return;
      }
      this.close();
    }

    handleAction(event) {
      var remove = event.target.closest('[data-mcube-remove-reference]');
      if (remove) {
        var store = wishlistStore();
        if (!store) return;
        var item = remove.closest('.mcube-drawer-item');
        var focusItem = item && (item.nextElementSibling || item.previousElementSibling);
        this.pendingFocusKey = focusItem ? focusItem.dataset.key : '__close__';
        var removeReference = store.getAll().find(function (reference) {
          return referenceKey(reference) === remove.dataset.key;
        });
        if (removeReference) store.remove(removeReference);
        return;
      }

      if (event.target.closest('[data-mcube-share-wishlist]')) {
        this.share();
        return;
      }

      if (event.target.closest('[data-mcube-drawer-clear-selection]')) {
        this.selected.clear();
        this.syncSelectionUI();
        return;
      }

      var projectOpen = event.target.closest('[data-mcube-drawer-project-open]');
      if (projectOpen) {
        this.openProjectPicker(projectOpen);
        return;
      }

      if (event.target.closest('[data-mcube-drawer-project-back]')) {
        this.closeProjectPicker(true);
      }
    }

    handleChange(event) {
      if (event.target.matches('[data-mcube-drawer-item-select]')) {
        if (event.target.checked) this.selected.add(event.target.value);
        else this.selected.delete(event.target.value);
        this.syncSelectionUI();
        return;
      }

      if (!event.target.matches('input[name="drawer_project_choice"]')) return;
      this.syncNewProjectField(event.target.value === '__new__', true);
    }

    share() {
      var store = wishlistStore();
      if (store && store.count()) openWhatsApp(buildWishlistMessage(store.getAll()));
    }

    selectedReferences() {
      var selected = this.selected;
      var store = wishlistStore();
      if (!store) return [];
      return store.getAll().filter(function (reference) {
        return selected.has(referenceKey(reference));
      });
    }

    syncSelectionUI() {
      var count = this.selected.size;
      this.querySelectorAll('[data-mcube-drawer-item-select]').forEach(function (checkbox) {
        checkbox.checked = this.selected.has(checkbox.value);
        var item = checkbox.closest('.mcube-drawer-item');
        if (item) item.classList.toggle('is-selected', checkbox.checked);
      }, this);

      if (this.selectionCount) this.selectionCount.textContent = String(count);
      if (this.projectCount) this.projectCount.textContent = String(count);
      if (this.projectPlural) this.projectPlural.hidden = count === 1;
      if (this.selectionActions) this.selectionActions.hidden = this.projectPickerOpen || count === 0;
      this.classList.toggle('has-selection', count > 0);
      this.syncProjectAction();

      if (!count && this.projectPickerOpen) this.closeProjectPicker(false);
    }

    syncProjectAction() {
      if (!this.projectOpenButton) return;
      var store = projectStore();
      var hasProjects = store && store.getAll().length > 0;
      this.projectOpenButton.textContent = hasProjects ? 'Add to Project' : 'Create Project & Add';
      this.projectOpenButton.setAttribute('aria-expanded', String(this.projectPickerOpen));
    }

    populateProjectOptions() {
      var store = projectStore();
      if (!store || !this.projectOptions) return;
      var projects = store.getAll();
      var checked = this.projectOptions.querySelector('input[name="drawer_project_choice"]:checked');
      var wasCreating = this.newProjectField && !this.newProjectField.hidden;
      var wanted = checked ? checked.value : (wasCreating ? '__new__' : '');
      if (wanted !== '__new__' && !projects.some(function (project) { return project.id === wanted; })) wanted = '';
      var rows = projects.map(function (project, index) {
        var entries = projectItems(project);
        var sceneCount = entries.filter(function (entry) { return referenceType(itemReference(entry.item)) === 'scene'; }).length;
        var materialCount = entries.length - sceneCount;
        var isChecked = wanted ? wanted === project.id : index === 0;
        return '<label class="mcube-choice-row"><input type="radio" name="drawer_project_choice" value="' + escapeHtml(project.id) + '"' + (isChecked ? ' checked' : '') + '><span><strong>' + escapeHtml(project.name) + '</strong><small>' + materialCount + ' material' + (materialCount === 1 ? '' : 's') + (sceneCount ? ' · ' + sceneCount + ' inspiration' + (sceneCount === 1 ? '' : 's') : '') + '</small></span></label>';
      });
      var useNew = wanted === '__new__' || !projects.length;
      if (projects.length) rows.push('<label class="mcube-choice-row"><input type="radio" name="drawer_project_choice" value="__new__"' + (useNew ? ' checked' : '') + '><span><strong>Create a new Project</strong><small>Start a fresh material schedule.</small></span></label>');
      this.projectOptions.innerHTML = rows.join('');
      this.projectOptions.hidden = projects.length === 0;
      this.syncNewProjectField(useNew, false);
      if (this.projectTitle) this.projectTitle.textContent = projects.length ? 'Add to a Project' : 'Create a Project';
      if (this.projectSubmit) this.projectSubmit.textContent = projects.length ? 'Add selected items' : 'Create Project & Add';
    }

    syncNewProjectField(show, focusInput) {
      if (!this.newProjectField) return;
      this.newProjectField.hidden = !show;
      var input = this.newProjectField.querySelector('input');
      if (!input) return;
      input.required = show;
      if (show && focusInput) input.focus();
    }

    openProjectPicker(trigger) {
      if (!this.selected.size || !projectStore()) return;
      this.projectTrigger = trigger || document.activeElement;
      this.populateProjectOptions();
      this.projectPickerOpen = true;
      if (this.listView) this.listView.hidden = true;
      if (this.projectView) this.projectView.hidden = false;
      if (this.regularActions) this.regularActions.hidden = true;
      if (this.selectionActions) this.selectionActions.hidden = true;
      if (this.projectActions) this.projectActions.hidden = false;
      this.classList.add('is-project-picker-open');
      this.syncSelectionUI();
      if (this.panel) {
        var scrollable = this.querySelector('[data-scroll-lock-scrollable]');
        if (scrollable) scrollable.scrollTop = 0;
      }
      var hasProjects = projectStore().getAll().length > 0;
      var focusTarget = this.projectView && this.projectView.querySelector(hasProjects ? 'input:checked' : '[name="project_name"]');
      if (focusTarget) focusTarget.focus();
    }

    closeProjectPicker(restoreFocus) {
      this.projectPickerOpen = false;
      if (this.listView) this.listView.hidden = false;
      if (this.projectView) this.projectView.hidden = true;
      if (this.regularActions) this.regularActions.hidden = false;
      if (this.projectActions) this.projectActions.hidden = true;
      this.classList.remove('is-project-picker-open');
      this.syncSelectionUI();
      if (restoreFocus && this.projectTrigger && typeof this.projectTrigger.focus === 'function') {
        this.projectTrigger.focus();
      }
    }

    addToProject(event) {
      event.preventDefault();
      var store = projectStore();
      if (!store) return;
      var references = this.selectedReferences();
      if (!references.length) return;
      var form = event.currentTarget;
      var choice = form.querySelector('input[name="drawer_project_choice"]:checked');
      var projectId = choice ? choice.value : (store.getAll().length ? '' : '__new__');
      if (!projectId) return;

      if (projectId === '__new__') {
        var name = form.elements.project_name.value.trim();
        if (!name) {
          form.elements.project_name.focus();
          return;
        }
        var created = store.create(name);
        projectId = created && created.id;
      }

      if (!projectId) return;
      var added = typeof store.addItems === 'function'
        ? store.addItems(projectId, references)
        : references.map(function (reference) { return store.addItem(projectId, reference); }).filter(Boolean);
      var project = store.get(projectId);
      var skipped = references.length - added.length;
      var message = added.length + ' item' + (added.length === 1 ? '' : 's') + ' added to ' + (project ? project.name : 'the Project') + '.';
      if (!added.length && skipped) message = (references.length === 1 ? 'That item is' : 'Those items are') + ' already in ' + (project ? project.name : 'the Project') + '.';
      else if (skipped) message += ' ' + skipped + (skipped === 1 ? ' was' : ' were') + ' already there.';

      this.selected.clear();
      this.closeProjectPicker(false);
      this.syncSelectionUI();
      if (form.elements.project_name) form.elements.project_name.value = '';
      if (this.newProjectField) {
        this.newProjectField.hidden = true;
        if (form.elements.project_name) form.elements.project_name.required = false;
      }
      if (this.projectOptions) this.projectOptions.innerHTML = '';
      globalNotice(message);
    }

    render() {
      var store = wishlistStore();
      if (!store) return;
      var references = store.getAll();
      var validKeys = new Set(references.map(referenceKey));
      this.selected.forEach(function (key) {
        if (!validKeys.has(key)) this.selected.delete(key);
      }, this);
      var renderId = String(Date.now()) + Math.random();
      this.__mcubeRenderId = renderId;
      if (this.countElement) this.countElement.textContent = padCount(references.length);
      if (this.wishlistActions) this.wishlistActions.hidden = references.length === 0;
      this.syncSelectionUI();

      if (!references.length) {
        this.selected.clear();
        if (this.projectPickerOpen) this.closeProjectPicker(false);
        this.statusElement.innerHTML = '<div class="mcube-drawer-empty"><span class="mcube-drawer-empty__mark" aria-hidden="true"></span><h3>Nothing saved yet</h3><p>Save products or inspiration scenes to build a Wishlist for your next space.</p></div>';
        this.itemsElement.innerHTML = '';
        this.syncSelectionUI();
        if (this.pendingFocusKey) {
          var closeButton = this.querySelector('[data-mcube-drawer-close]');
          if (closeButton) closeButton.focus();
          this.pendingFocusKey = '';
        }
        return;
      }

      this.statusElement.innerHTML = '<div class="mcube-loading-panel"><span class="mcube-loading-panel__mark" aria-hidden="true"></span><p>Loading saved items...</p></div>';
      this.itemsElement.innerHTML = '';

      resolveReferences(references).then(function (products) {
        if (this.__mcubeRenderId !== renderId) return;
        this.statusElement.innerHTML = '';
        var materialIndex = 0;
        this.itemsElement.innerHTML = products.map(function (product) {
          var reference = product.reference;
          var key = referenceKey(reference);
          var isScene = product.type === 'scene';
          var image = product.image
            ? '<img src="' + escapeHtml(product.image) + '" alt="" loading="lazy" width="184" height="184">'
            : emptyImageMarkup('No image');
          var meta = isScene
            ? '<p class="mcube-drawer-item__code">' + escapeHtml([product.room, product.style].filter(Boolean).join(' · ') || 'Visual reference') + '</p>'
            : '<p class="mcube-drawer-item__code">' + escapeHtml(product.code) + '</p>';
          var itemIndex = isScene ? '' : String(++materialIndex).padStart(2, '0');
          return '<article class="mcube-drawer-item' + (isScene ? ' mcube-drawer-item--scene' : '') + (product.missing ? ' mcube-drawer-item--missing' : '') + (this.selected.has(key) ? ' is-selected' : '') + '" data-key="' + escapeHtml(key) + '">' +
            '<label class="mcube-drawer-item__select"><input class="visually-hidden" type="checkbox" data-mcube-drawer-item-select value="' + escapeHtml(key) + '"' + (this.selected.has(key) ? ' checked' : '') + '><span aria-hidden="true">&#10003;</span><span class="visually-hidden">Select ' + escapeHtml(product.title) + '</span></label>' +
            '<a class="mcube-drawer-item__image" href="' + escapeHtml(product.url) + '" aria-label="View ' + escapeHtml(product.title) + '">' + image + '</a>' +
            '<div class="mcube-drawer-item__meta"><span class="mcube-drawer-item__index">' + (isScene ? 'Inspiration scene' : 'Material ' + itemIndex) + '</span>' +
            '<a class="mcube-drawer-item__title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
            meta + '</div>' +
            '<button type="button" class="mcube-icon-button mcube-drawer-item__remove" data-mcube-remove-reference data-key="' + escapeHtml(key) + '" aria-label="Remove ' + escapeHtml(product.title) + ' from Wishlist">&times;</button>' +
            '</article>';
        }, this).join('');
        this.syncSelectionUI();
        if (this.pendingFocusKey) {
          var nextItem = Array.prototype.find.call(this.itemsElement.querySelectorAll('.mcube-drawer-item'), function (element) {
            return element.dataset.key === this.pendingFocusKey;
          }, this);
          var focusTarget = nextItem && nextItem.querySelector('[data-mcube-remove-reference]');
          if (!focusTarget) focusTarget = this.querySelector('[data-mcube-drawer-close]');
          if (focusTarget) focusTarget.focus();
          this.pendingFocusKey = '';
        }
      }.bind(this));
    }
  }

  class MCubeWishlistPage extends HTMLElement {
    connectedCallback() {
      if (this.__mcubeReady) return;
      this.__mcubeReady = true;
      this.grid = this.querySelector('[data-mcube-wishlist-grid]');
      this.statusElement = this.querySelector('[data-mcube-wishlist-page-status]');
      this.countElements = this.querySelectorAll('[data-mcube-wishlist-page-count]');
      this.materialCountElement = this.querySelector('[data-mcube-wishlist-material-count]');
      this.sceneCountElement = this.querySelector('[data-mcube-wishlist-scene-count]');
      this.toolbar = this.querySelector('[data-mcube-wishlist-toolbar]');
      this.selectAll = this.querySelector('[data-mcube-select-all]');
      this.selectionBar = this.querySelector('[data-mcube-selection-bar]');
      this.selectionCount = this.querySelector('[data-mcube-selection-count]');
      this.projectDialog = this.querySelector('[data-mcube-project-dialog]');
      this.clearDialog = this.querySelector('[data-mcube-clear-dialog]');
      this.projectOptions = this.querySelector('[data-mcube-project-options]');
      this.newProjectField = this.querySelector('[data-mcube-new-project-field]');
      this.toast = this.querySelector('[data-mcube-toast]');
      this.projectsUrl = this.dataset.projectsUrl || rootUrl() + 'pages/projects';
      this.selected = new Set();
      this.products = [];
      this.entries = [];
      this.activeFilter = 'all';
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', this.handleChange.bind(this));
      var projectForm = this.querySelector('[data-mcube-project-form]');
      var clearForm = this.querySelector('[data-mcube-clear-form]');
      if (projectForm) projectForm.addEventListener('submit', this.addToProject.bind(this));
      if (clearForm) clearForm.addEventListener('submit', this.clearWishlist.bind(this));
      bindDialogClosers(this);
      this.bindStore();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    bindStore() {
      var store = wishlistStore();
      if (!store) {
        window.setTimeout(this.bindStore.bind(this), 60);
        return;
      }
      this.unsubscribe = store.subscribe(this.render.bind(this));
      this.render();
    }

    handleClick(event) {
      var filterButton = event.target.closest('[data-mcube-wishlist-filter]');
      if (filterButton) {
        this.activeFilter = filterButton.dataset.mcubeWishlistFilter || 'all';
        this.renderFilteredCards();
        return;
      }
      var remove = event.target.closest('[data-mcube-page-remove]');
      if (remove) {
        wishlistStore().remove(this.referenceForKey(remove.dataset.key));
        return;
      }
      if (event.target.closest('[data-mcube-share-all]')) {
        openWhatsApp(buildWishlistMessage(wishlistStore().getAll()));
        return;
      }
      if (event.target.closest('[data-mcube-share-selected]')) {
        openWhatsApp(buildWishlistMessage(this.selectedReferences(), 'M Cube Spaces Selected Wishlist'));
        return;
      }
      if (event.target.closest('[data-mcube-remove-selected]')) {
        this.selectedReferences().forEach(function (reference) { wishlistStore().remove(reference); });
        this.selected.clear();
        return;
      }
      if (event.target.closest('[data-mcube-project-open]')) {
        this.openProjectPicker(event.target.closest('[data-mcube-project-open]'));
        return;
      }
      if (event.target.closest('[data-mcube-clear-open]')) {
        showDialog(this.clearDialog, event.target.closest('[data-mcube-clear-open]'));
      }
    }

    handleChange(event) {
      if (event.target.matches('[data-mcube-select-all]')) {
        var checked = event.target.checked;
        this.selected.clear();
        if (checked) wishlistStore().getAll().forEach(function (reference) { this.selected.add(referenceKey(reference)); }, this);
        this.syncSelectionUI();
        return;
      }

      if (event.target.matches('[data-mcube-item-select]')) {
        if (event.target.checked) this.selected.add(event.target.value);
        else this.selected.delete(event.target.value);
        this.syncSelectionUI();
        return;
      }

      if (event.target.matches('input[name="project_choice"]')) {
        var isNew = event.target.value === '__new__';
        this.newProjectField.hidden = !isNew;
        var input = this.newProjectField.querySelector('input');
        input.required = isNew;
        if (isNew) input.focus();
      }
    }

    referenceForKey(key) {
      return wishlistStore().getAll().find(function (reference) { return referenceKey(reference) === key; }) || null;
    }

    selectedReferences() {
      var selected = this.selected;
      return wishlistStore().getAll().filter(function (reference) { return selected.has(referenceKey(reference)); });
    }

    syncSelectionUI() {
      var count = this.selected.size;
      this.querySelectorAll('[data-mcube-item-select]').forEach(function (checkbox) {
        checkbox.checked = this.selected.has(checkbox.value);
        var card = checkbox.closest('.mcube-material-card, .mcube-native-card, .mcube-inspiration-card');
        if (card) card.classList.toggle('is-selected', checkbox.checked);
      }, this);
      if (this.selectionBar) this.selectionBar.hidden = count === 0;
      this.classList.toggle('has-selection', count > 0);
      if (this.selectionCount) this.selectionCount.textContent = String(count);
      if (this.selectAll) {
        var total = wishlistStore().count();
        this.selectAll.checked = total > 0 && count === total;
        this.selectAll.indeterminate = count > 0 && count < total;
      }
    }

    openProjectPicker(trigger) {
      var store = projectStore();
      if (!store || !this.selected.size) return;
      var projects = store.getAll();
      var rows = projects.map(function (project, index) {
        var entries = projectItems(project);
        var scenes = entries.filter(function (entry) { return referenceType(itemReference(entry.item)) === 'scene'; }).length;
        var materials = entries.length - scenes;
        return '<label class="mcube-choice-row"><input type="radio" name="project_choice" value="' + escapeHtml(project.id) + '"' + (index === 0 ? ' checked' : '') + '><span><strong>' + escapeHtml(project.name) + '</strong><small>' + materials + ' material' + (materials === 1 ? '' : 's') + (scenes ? ' · ' + scenes + ' inspiration' + (scenes === 1 ? '' : 's') : '') + '</small></span></label>';
      });
      rows.push('<label class="mcube-choice-row"><input type="radio" name="project_choice" value="__new__"' + (!projects.length ? ' checked' : '') + '><span><strong>Create a new Project</strong><small>Start a fresh material schedule.</small></span></label>');
      this.projectOptions.innerHTML = rows.join('');
      var useNew = projects.length === 0;
      this.newProjectField.hidden = !useNew;
      var nameInput = this.newProjectField.querySelector('input');
      nameInput.required = useNew;
      nameInput.value = '';
      showDialog(this.projectDialog, trigger);
    }

    addToProject(event) {
      event.preventDefault();
      var store = projectStore();
      if (!store) return;
      var form = event.currentTarget;
      var choice = form.querySelector('input[name="project_choice"]:checked');
      if (!choice) return;
      var projectId = choice.value;
      if (projectId === '__new__') {
        var name = form.elements.project_name.value.trim();
        if (!name) {
          form.elements.project_name.focus();
          return;
        }
        var created = store.create(name);
        projectId = created && created.id;
      }
      if (!projectId) return;
      var references = this.selectedReferences();
      var added = typeof store.addItems === 'function'
        ? store.addItems(projectId, references)
        : references.map(function (reference) { return store.addItem(projectId, reference); }).filter(Boolean);
      closeDialog(this.projectDialog);
      announce(this.toast, added.length + ' item' + (added.length === 1 ? '' : 's') + ' added to the Project.');
    }

    clearWishlist(event) {
      event.preventDefault();
      wishlistStore().clear();
      this.selected.clear();
      closeDialog(this.clearDialog);
    }

    materialCard(entry, index) {
      var product = entry.product;
      var key = referenceKey(entry.reference);
      var fallback = '<div class="mcube-native-card__fallback">' +
        (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="" loading="lazy">' : emptyImageMarkup('Product unavailable')) +
        '<div><span class="mcube-technical-label">Saved material</span><h2><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></h2></div></div>';
      return '<article class="mcube-native-card' + (!entry.html ? ' mcube-native-card--fallback' : '') + '" data-key="' + escapeHtml(key) + '">' +
        '<label class="mcube-material-card__select"><input class="visually-hidden" type="checkbox" data-mcube-item-select value="' + escapeHtml(key) + '"><span aria-hidden="true">✓</span><span class="visually-hidden">Select ' + escapeHtml(product.title) + '</span></label>' +
        '<div class="mcube-native-card__product">' + (entry.html || fallback) + '</div>' +
        '<footer class="mcube-native-card__footer"><span class="mcube-material-card__index">Material ' + String(index + 1).padStart(2, '0') + '</span><span class="mcube-material-card__code">' + escapeHtml(product.code) + '</span>' +
        '<button type="button" class="mcube-material-card__remove" data-mcube-page-remove data-key="' + escapeHtml(key) + '">Remove</button></footer></article>';
    }

    inspirationCard(entry) {
      var scene = entry.product;
      var key = referenceKey(entry.reference);
      var meta = [scene.room, scene.style].filter(Boolean).join(' · ') || 'Visual reference';
      var image = scene.image
        ? '<img src="' + escapeHtml(scene.image) + '" alt="" loading="lazy">'
        : emptyImageMarkup('Scene unavailable');
      return '<article class="mcube-inspiration-card" data-key="' + escapeHtml(key) + '">' +
        '<label class="mcube-material-card__select"><input class="visually-hidden" type="checkbox" data-mcube-item-select value="' + escapeHtml(key) + '"><span aria-hidden="true">&#10003;</span><span class="visually-hidden">Select ' + escapeHtml(scene.title) + '</span></label>' +
        '<a class="mcube-inspiration-card__media" href="' + escapeHtml(scene.url) + '" aria-label="View ' + escapeHtml(scene.title) + '">' + image + '<span>Inspiration Scene</span></a>' +
        '<div class="mcube-inspiration-card__body"><p class="mcube-inspiration-card__meta">' + escapeHtml(meta) + '</p><h2><a href="' + escapeHtml(scene.url) + '">' + escapeHtml(scene.title) + '</a></h2>' +
        '<div class="mcube-inspiration-card__footer"><span>Saved visual direction</span><button type="button" class="mcube-material-card__remove" data-mcube-page-remove data-key="' + escapeHtml(key) + '">Remove</button></div></div></article>';
    }

    renderFilteredCards() {
      var filter = this.activeFilter;
      var visible = this.entries.filter(function (entry) {
        var type = referenceType(entry.reference);
        return filter === 'all' || (filter === 'materials' && type === 'product') || (filter === 'inspiration' && type === 'scene');
      });
      this.querySelectorAll('[data-mcube-wishlist-filter]').forEach(function (button) {
        var active = button.dataset.mcubeWishlistFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      var materialIndex = 0;
      this.grid.innerHTML = visible.map(function (entry) {
        if (referenceType(entry.reference) === 'scene') return this.inspirationCard(entry);
        var markup = this.materialCard(entry, materialIndex);
        materialIndex += 1;
        return markup;
      }, this).join('');
      this.statusElement.innerHTML = visible.length ? '' : '<p class="mcube-filter-empty">No saved items match this filter.</p>';
      this.syncSelectionUI();
    }

    render() {
      var store = wishlistStore();
      if (!store) return;
      var references = store.getAll();
      var validKeys = new Set(references.map(referenceKey));
      this.selected.forEach(function (key) { if (!validKeys.has(key)) this.selected.delete(key); }, this);
      this.countElements.forEach(function (element) {
        element.textContent = element.classList.contains('mcube-page__summary-number') ? padCount(references.length) : String(references.length);
      });
      var sceneCount = references.filter(function (reference) { return referenceType(reference) === 'scene'; }).length;
      var materialCount = references.length - sceneCount;
      if (this.materialCountElement) this.materialCountElement.textContent = String(materialCount);
      if (this.sceneCountElement) this.sceneCountElement.textContent = String(sceneCount);
      if (this.toolbar) this.toolbar.hidden = references.length === 0;
      var renderId = String(Date.now()) + Math.random();
      this.__mcubeRenderId = renderId;

      if (!references.length) {
        this.entries = [];
        this.statusElement.innerHTML = '<div class="mcube-page-empty"><span class="mcube-page-empty__mark" aria-hidden="true"></span><p class="mcube-kicker">A clean sample board</p><h2>Your Wishlist is ready for its first idea.</h2><p>Save products or inspiration scenes to keep materials and visual direction together.</p><div class="mcube-page-empty__actions"><a class="btn btn--primary btn--solid" href="' + escapeHtml(rootUrl() + 'collections/all') + '">Explore materials</a><a class="btn btn--primary btn--outline" href="' + escapeHtml(this.projectsUrl) + '">View My Projects</a></div></div>';
        this.grid.innerHTML = '';
        this.syncSelectionUI();
        return;
      }

      this.statusElement.innerHTML = '<div class="mcube-loading-panel"><span class="mcube-loading-panel__mark" aria-hidden="true"></span><p>Preparing your Wishlist board...</p></div>';
      this.grid.innerHTML = '';
      fetchWishlistCards(references).then(function (entries) {
        if (this.__mcubeRenderId !== renderId) return;
        this.entries = entries;
        this.products = entries.map(function (entry) { return entry.product; });
        this.renderFilteredCards();
      }.bind(this));
    }
  }

  class MCubeProjectManager extends HTMLElement {
    connectedCallback() {
      if (this.__mcubeReady) return;
      this.__mcubeReady = true;
      this.view = this.querySelector('[data-mcube-project-view]');
      this.statusElement = this.querySelector('[data-mcube-project-status]');
      this.toast = this.querySelector('[data-mcube-toast]');
      this.editorDialog = this.querySelector('[data-mcube-project-editor]');
      this.editorForm = this.querySelector('[data-mcube-project-editor-form]');
      this.deleteDialog = this.querySelector('[data-mcube-delete-dialog]');
      this.deleteForm = this.querySelector('[data-mcube-delete-form]');
      this.sectionDeleteDialog = this.querySelector('[data-mcube-section-delete-dialog]');
      this.sectionDeleteForm = this.querySelector('[data-mcube-section-delete-form]');
      this.saveTimers = {};
      this.pendingFocus = null;
      this.detailsMedia = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
      this.onDetailsMediaChange = this.syncDetailsVisibility.bind(this);
      if (this.detailsMedia) {
        if (typeof this.detailsMedia.addEventListener === 'function') this.detailsMedia.addEventListener('change', this.onDetailsMediaChange);
        else if (typeof this.detailsMedia.addListener === 'function') this.detailsMedia.addListener(this.onDetailsMediaChange);
      }
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', this.handleChange.bind(this));
      this.addEventListener('input', this.handleInput.bind(this));
      this.editorForm.addEventListener('submit', this.submitEditor.bind(this));
      this.deleteForm.addEventListener('submit', this.submitDelete.bind(this));
      this.sectionDeleteForm.addEventListener('submit', this.submitSectionDelete.bind(this));
      this.onPopState = function () {
        this.pendingFocus = {
          type: 'view',
          announcement: this.currentProjectId() ? 'Project detail opened.' : 'Projects dashboard opened.'
        };
        this.render();
      }.bind(this);
      window.addEventListener('popstate', this.onPopState);
      this.onPageHide = this.flushPendingFields.bind(this);
      window.addEventListener('pagehide', this.onPageHide);
      bindDialogClosers(this);
      this.bindStore();
    }

    disconnectedCallback() {
      this.flushPendingFields();
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('popstate', this.onPopState);
      window.removeEventListener('pagehide', this.onPageHide);
      if (this.detailsMedia) {
        if (typeof this.detailsMedia.removeEventListener === 'function') this.detailsMedia.removeEventListener('change', this.onDetailsMediaChange);
        else if (typeof this.detailsMedia.removeListener === 'function') this.detailsMedia.removeListener(this.onDetailsMediaChange);
      }
      Object.keys(this.saveTimers).forEach(function (key) { window.clearTimeout(this.saveTimers[key]); }, this);
    }

    bindStore() {
      var store = projectStore();
      if (!store) {
        window.setTimeout(this.bindStore.bind(this), 60);
        return;
      }
      this.unsubscribe = store.subscribe(function (payload) {
        if (payload && (payload.source === 'update-note' || payload.source === 'update-requirement')) return;
        this.render();
      }.bind(this));
      this.render();
    }

    currentProjectId() {
      return new URLSearchParams(window.location.search).get('project') || '';
    }

    navigate(projectId) {
      this.flushPendingFields();
      var url = new URL(window.location.href);
      if (projectId) url.searchParams.set('project', projectId);
      else url.searchParams.delete('project');
      window.history.pushState({}, '', url.pathname + url.search + url.hash);
      this.pendingFocus = {
        type: 'view',
        announcement: projectId ? 'Project detail opened.' : 'Projects dashboard opened.'
      };
      this.render();
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: this.closest('.mcube-page').offsetTop, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    announceView(message) {
      if (!this.statusElement || !message) return;
      this.statusElement.innerHTML = '<span class="visually-hidden">' + escapeHtml(message) + '</span>';
      window.clearTimeout(this.viewAnnouncementTimer);
      this.viewAnnouncementTimer = window.setTimeout(function () {
        if (this.statusElement.textContent.trim() === message) this.statusElement.innerHTML = '';
      }.bind(this), 1200);
    }

    restorePendingFocus() {
      if (!this.pendingFocus) return;
      var pending = this.pendingFocus;
      var target = null;

      if (pending.type === 'view') {
        target = this.view.querySelector('[data-mcube-view-heading]');
      } else if (pending.type === 'item-move') {
        var item = Array.prototype.find.call(this.view.querySelectorAll('[data-project-item]'), function (element) {
          return element.dataset.projectItem === pending.itemId;
        });
        target = item && item.querySelector('[data-mcube-project-item-move]');
      } else if (pending.type === 'section') {
        var section = Array.prototype.find.call(this.view.querySelectorAll('[data-project-section-id]'), function (element) {
          return element.dataset.projectSectionId === pending.sectionId;
        });
        target = section && section.querySelector('[data-mcube-section-heading]');
      }

      if (!target) return;
      target.focus({ preventScroll: true });
      this.pendingFocus = null;
      if (pending.announcement) this.announceView(pending.announcement);
    }

    totalItems(project) {
      return projectItems(project).length;
    }

    syncDetailsVisibility() {
      if (!this.view) return;
      var expanded = this.detailsMedia ? this.detailsMedia.matches : window.innerWidth >= 750;
      this.view.querySelectorAll('.mcube-project-item__details').forEach(function (details) {
        details.open = expanded;
      });
    }

    handleClick(event) {
      var target = event.target.closest('[data-mcube-action], [data-mcube-project-open], [data-mcube-project-rename], [data-mcube-project-share], [data-mcube-project-delete], [data-mcube-section-rename], [data-mcube-section-delete], [data-mcube-project-item-remove]');
      if (!target) return;
      var store = projectStore();
      if (!store) return;

      if (target.matches('[data-mcube-project-open]')) {
        this.navigate(target.dataset.projectId);
        return;
      }

      var action = target.dataset.mcubeAction;
      if (action === 'dashboard') {
        event.preventDefault();
        this.navigate('');
      } else if (action === 'create-project') {
        this.openEditor('create', '', '', target);
      } else if (action === 'rename-current') {
        var current = store.get(this.currentProjectId());
        if (current) this.openEditor('rename-project', current.id, current.name, target);
      } else if (action === 'add-section') {
        this.openEditor('add-section', this.currentProjectId(), '', target);
      } else if (action === 'share-current') {
        var shareProject = store.get(this.currentProjectId());
        if (shareProject) openWhatsApp(buildProjectMessage(shareProject));
      } else if (action === 'delete-current') {
        var deleteProject = store.get(this.currentProjectId());
        if (deleteProject) this.openDelete('project', deleteProject.id, deleteProject.name, target);
      } else if (target.matches('[data-mcube-project-rename]')) {
        var renameProject = store.get(target.dataset.projectId);
        if (renameProject) this.openEditor('rename-project', renameProject.id, renameProject.name, target);
      } else if (target.matches('[data-mcube-project-share]')) {
        var project = store.get(target.dataset.projectId);
        if (project) openWhatsApp(buildProjectMessage(project));
      } else if (target.matches('[data-mcube-project-delete]')) {
        var selectedProject = store.get(target.dataset.projectId);
        if (selectedProject) this.openDelete('project', selectedProject.id, selectedProject.name, target);
      } else if (target.matches('[data-mcube-section-rename]')) {
        this.openEditor('rename-section', target.dataset.sectionId, target.dataset.sectionName, target);
      } else if (target.matches('[data-mcube-section-delete]')) {
        this.sectionDeleteForm.elements.section_id.value = target.dataset.sectionId;
        showDialog(this.sectionDeleteDialog, target);
      } else if (target.matches('[data-mcube-project-item-remove]')) {
        var itemSection = target.closest('[data-project-section-id]');
        this.pendingFocus = {
          type: 'section',
          sectionId: itemSection ? itemSection.dataset.projectSectionId : '__unassigned__',
          announcement: 'Item removed. Focus returned to its room.'
        };
        if (store.removeItem(this.currentProjectId(), target.dataset.itemId)) announce(this.toast, 'Item removed from this Project.');
      }
    }

    handleChange(event) {
      if (event.target.matches('[data-mcube-project-field]')) {
        this.saveField(event.target);
        return;
      }
      if (!event.target.matches('[data-mcube-project-item-move]')) return;
      if (!event.target.value) return;
      var sectionId = event.target.value === '__unassigned__' ? null : event.target.value;
      this.pendingFocus = {
        type: 'item-move',
        itemId: event.target.dataset.itemId,
        announcement: 'Item moved to ' + event.target.options[event.target.selectedIndex].text + '.'
      };
      if (projectStore().moveItem(this.currentProjectId(), event.target.dataset.itemId, sectionId)) {
        announce(this.toast, 'Item moved.');
      }
    }

    handleInput(event) {
      if (!event.target.matches('[data-mcube-project-field]')) return;
      var input = event.target;
      var itemId = input.dataset.itemId;
      var field = input.dataset.field;
      var timerKey = itemId + ':' + field;
      var item = input.closest('.mcube-project-item');
      var status = item.querySelector('[data-mcube-save-status]');
      if (status) status.textContent = 'Saving...';
      this.updateDetailsSummary(item);
      window.clearTimeout(this.saveTimers[timerKey]);
      this.saveTimers[timerKey] = window.setTimeout(function () {
        this.saveField(input);
      }.bind(this), 500);
    }

    updateDetailsSummary(item) {
      if (!item) return;
      var summary = item.querySelector('[data-mcube-details-summary]');
      var details = item.querySelector('.mcube-project-item__details');
      var requirement = item.querySelector('[data-field="requirement"]');
      var note = item.querySelector('[data-field="note"]');
      var labels = [];
      if (requirement && requirement.value.trim()) labels.push('Requirement set');
      if (note && note.value.trim()) labels.push('Notes added');
      if (summary) summary.textContent = labels.length ? labels.join(' · ') : 'Optional';
      if (details) details.classList.toggle('has-content', labels.length > 0);
    }

    saveField(input) {
      if (!input || !input.matches('[data-mcube-project-field]')) return;
      var itemId = input.dataset.itemId;
      var field = input.dataset.field;
      var timerKey = itemId + ':' + field;
      window.clearTimeout(this.saveTimers[timerKey]);
      delete this.saveTimers[timerKey];

      var store = projectStore();
      if (!store) return;
      var saved = field === 'note'
        ? store.updateItemNote(this.currentProjectId(), itemId, input.value)
        : store.updateItemRequirement(this.currentProjectId(), itemId, input.value);
      var item = input.closest('.mcube-project-item');
      var status = item && item.querySelector('[data-mcube-save-status]');
      if (status) status.textContent = saved ? 'Saved' : 'Could not save';
      window.setTimeout(function () {
        if (status && status.textContent === 'Saved') status.textContent = '';
      }, 1800);
    }

    flushPendingFields() {
      if (!this.saveTimers) return;
      this.querySelectorAll('[data-mcube-project-field]').forEach(function (input) {
        var timerKey = input.dataset.itemId + ':' + input.dataset.field;
        if (this.saveTimers[timerKey]) this.saveField(input);
      }, this);
    }

    openEditor(mode, entityId, value, trigger) {
      var title = this.editorForm.querySelector('[data-mcube-project-editor-title]');
      var kicker = this.editorForm.querySelector('[data-mcube-project-editor-kicker]');
      var label = this.editorForm.querySelector('[data-mcube-project-editor-label]');
      var submit = this.editorForm.querySelector('[data-mcube-project-editor-submit]');
      var names = {
        create: ['New specification', 'Create a Project', 'Project name', 'Create Project'],
        'rename-project': ['Project details', 'Rename Project', 'Project name', 'Save name'],
        'add-section': ['Project structure', 'Add a Room', 'Room name', 'Add room'],
        'rename-section': ['Room details', 'Rename Room', 'Room name', 'Save name']
      };
      var copy = names[mode] || names.create;
      kicker.textContent = copy[0];
      title.textContent = copy[1];
      label.textContent = copy[2];
      submit.textContent = copy[3];
      this.editorForm.elements.mode.value = mode;
      this.editorForm.elements.entity_id.value = entityId || '';
      this.editorForm.elements.name.value = value || '';
      showDialog(this.editorDialog, trigger);
      this.editorForm.elements.name.select();
    }

    submitEditor(event) {
      event.preventDefault();
      var store = projectStore();
      var mode = this.editorForm.elements.mode.value;
      var id = this.editorForm.elements.entity_id.value;
      var name = this.editorForm.elements.name.value.trim();
      if (!name) return;
      var result = null;
      if (mode === 'create') result = store.create(name);
      if (mode === 'rename-project') result = store.rename(id, name);
      if (mode === 'add-section') result = store.addSection(id, name);
      if (mode === 'rename-section') result = store.renameSection(this.currentProjectId(), id, name);
      closeDialog(this.editorDialog);
      if (mode === 'create' && result) this.navigate(result.id);
      else if (result) announce(this.toast, mode.indexOf('section') > -1 ? 'Project room updated.' : 'Project updated.');
    }

    openDelete(mode, id, name, trigger) {
      this.deleteForm.elements.mode.value = mode;
      this.deleteForm.elements.entity_id.value = id;
      this.deleteForm.querySelector('[data-mcube-delete-title]').textContent = 'Delete “' + name + '”?';
      this.deleteForm.querySelector('[data-mcube-delete-copy]').textContent = 'This removes the Project and its saved item notes from this browser. Your Wishlist will not be affected.';
      showDialog(this.deleteDialog, trigger);
    }

    submitDelete(event) {
      event.preventDefault();
      var id = this.deleteForm.elements.entity_id.value;
      var deleted = projectStore().delete(id);
      closeDialog(this.deleteDialog);
      if (deleted && id === this.currentProjectId()) this.navigate('');
      else if (deleted) announce(this.toast, 'Project deleted.');
    }

    submitSectionDelete(event) {
      event.preventDefault();
      var sectionId = this.sectionDeleteForm.elements.section_id.value;
      var mode = this.sectionDeleteForm.elements.section_delete_mode.value;
      var deleted = projectStore().deleteSection(this.currentProjectId(), sectionId, { moveItemsToUnassigned: mode === 'move' });
      closeDialog(this.sectionDeleteDialog);
      if (deleted) announce(this.toast, mode === 'move' ? 'Room deleted; saved items moved to Unassigned.' : 'Room and saved items deleted.');
    }

    projectCard(project) {
      var counts = projectCounts(project);
      var shareLabel = counts.materials ? 'Request Quote' : 'Share Project';
      return '<article class="mcube-project-card" data-project-card="' + escapeHtml(project.id) + '">' +
        '<div class="mcube-project-card__samples" data-project-samples="' + escapeHtml(project.id) + '"><span class="mcube-project-card__sample"></span><span class="mcube-project-card__sample"></span><span class="mcube-project-card__sample"></span></div>' +
        '<div class="mcube-project-card__body"><span class="mcube-technical-label">Project · ' + formatDate(project.updatedAt) + '</span>' +
        '<h2 class="mcube-project-card__title">' + escapeHtml(project.name) + '</h2>' +
        '<p class="mcube-project-card__meta">' + counts.materials + ' material' + (counts.materials === 1 ? '' : 's') + ' · ' + counts.scenes + ' inspiration' + (counts.scenes === 1 ? '' : 's') + ' · ' + (project.sections || []).length + ' room' + ((project.sections || []).length === 1 ? '' : 's') + '</p>' +
        '<div class="mcube-project-card__actions"><button type="button" data-mcube-project-open data-project-id="' + escapeHtml(project.id) + '">Open</button>' +
        '<button type="button" data-mcube-project-rename data-project-id="' + escapeHtml(project.id) + '">Rename</button>' +
        '<button type="button" data-mcube-project-share data-project-id="' + escapeHtml(project.id) + '">' + shareLabel + '</button>' +
        '<button type="button" data-mcube-project-delete data-project-id="' + escapeHtml(project.id) + '">Delete</button></div></div></article>';
    }

    renderDashboard(projects) {
      var heading = this.dataset.heading || 'My Projects';
      var description = this.dataset.description || '';
      var header = '<header class="mcube-project-dashboard__head"><div class="mcube-project-dashboard__copy"><p class="mcube-kicker">Material schedules &amp; inspiration</p><h1 class="mcube-project-dashboard__title" data-mcube-view-heading tabindex="-1">' + escapeHtml(heading) + '</h1><p class="mcube-project-dashboard__description">' + escapeHtml(description) + '</p></div><div class="mcube-project-dashboard__actions"><a class="btn btn--primary btn--outline" href="' + escapeHtml(this.dataset.wishlistUrl || '/pages/wishlist') + '">Open Wishlist</a><button type="button" class="btn btn--primary btn--solid" data-mcube-action="create-project">Create Project</button></div></header>';
      if (!projects.length) {
        this.view.innerHTML = header + '<div class="mcube-project-empty"><div><p class="mcube-kicker">Your first specification</p><h2>Build a design story room by room.</h2><p>Start a project, then organise Wishlist materials and inspiration scenes into rooms for client-ready planning.</p><button type="button" class="btn btn--primary btn--solid" data-mcube-action="create-project">Create your first Project</button></div><div class="mcube-project-empty__diagram" aria-hidden="true"><span class="mcube-project-empty__sheet"></span><span class="mcube-project-empty__sheet"></span><span class="mcube-project-empty__sheet"></span></div></div>';
        this.restorePendingFocus();
        return;
      }
      this.view.innerHTML = header + '<div class="mcube-project-grid">' + projects.map(this.projectCard.bind(this)).join('') + '</div>';
      this.restorePendingFocus();
      projects.forEach(this.hydrateProjectSamples.bind(this));
    }

    hydrateProjectSamples(project) {
      var holder = Array.prototype.find.call(this.querySelectorAll('[data-project-samples]'), function (element) {
        return element.dataset.projectSamples === project.id;
      });
      if (!holder) return;
      var references = projectItems(project).slice(0, 3).map(function (entry) { return itemReference(entry.item); });
      resolveReferences(references).then(function (products) {
        if (!holder.isConnected) return;
        var slots = holder.querySelectorAll('.mcube-project-card__sample');
        products.forEach(function (product, index) {
          if (slots[index] && product.image) slots[index].innerHTML = '<img src="' + escapeHtml(product.image) + '" alt="" loading="lazy">';
        });
      });
    }

    sectionMarkup(section, project, productsByItem, unassigned) {
      var items = section.items || [];
      var actions = unassigned ? '' : '<div class="mcube-project-section__actions"><button type="button" class="mcube-text-button" data-mcube-section-rename data-section-id="' + escapeHtml(section.id) + '" data-section-name="' + escapeHtml(section.name) + '">Rename</button><button type="button" class="mcube-text-button mcube-text-button--danger" data-mcube-section-delete data-section-id="' + escapeHtml(section.id) + '">Delete</button></div>';
      var content = items.length
        ? items.map(function (item) { return this.projectItemMarkup(item, project, productsByItem[item.id]); }, this).join('')
        : '<p class="mcube-project-section__empty">' + (unassigned ? 'Items added to this Project appear here until you move them into a room.' : 'No materials or inspiration scenes in this room yet.') + '</p>';
      var sectionKey = unassigned ? '__unassigned__' : section.id;
      var sectionClass = unassigned ? 'mcube-project-section--unassigned' : 'mcube-project-section--room';
      return '<section class="mcube-project-section ' + sectionClass + '" data-project-section-id="' + escapeHtml(sectionKey) + '"><header class="mcube-project-section__head"><div class="mcube-project-section__title-wrap"><h2 class="mcube-project-section__title" data-mcube-section-heading tabindex="-1">' + escapeHtml(section.name) + '</h2><span class="mcube-project-section__count">' + padCount(items.length) + '</span></div>' + actions + '</header><div class="mcube-project-section__items">' + content + '</div></section>';
    }

    projectItemMarkup(item, project, product) {
      var reference = itemReference(item);
      var isScene = referenceType(reference) === 'scene';
      product = product || (isScene ? normalizeScene(reference) : missingProduct(reference));
      var image = product.image ? '<img src="' + escapeHtml(product.image) + '" alt="" loading="lazy">' : emptyImageMarkup('No image');
      var currentSection = '';
      (project.sections || []).some(function (section) {
        if ((section.items || []).some(function (entry) { return entry.id === item.id; })) {
          currentSection = section.id;
          return true;
        }
        return false;
      });
      var destinations = [];
      if (currentSection) destinations.push('<option value="__unassigned__">Unassigned</option>');
      (project.sections || []).forEach(function (section) {
        if (section.id === currentSection) return;
        destinations.push('<option value="' + escapeHtml(section.id) + '">' + escapeHtml(section.name) + '</option>');
      });
      var hasDestinations = destinations.length > 0;
      var movePrompt = hasDestinations
        ? (currentSection ? 'Choose destination' : 'Choose a room')
        : 'Add a room first';
      var options = '<option value="" selected disabled>' + movePrompt + '</option>' + destinations.join('');
      var detailLabels = [];
      if (!isScene && item.requirement) detailLabels.push('Requirement set');
      if (item.note) detailLabels.push('Notes added');
      var detailSummary = detailLabels.length ? detailLabels.join(' · ') : 'Optional';
      var detailsOpen = this.detailsMedia && this.detailsMedia.matches ? ' open' : '';
      var identityMeta = isScene
        ? [product.room, product.style].filter(Boolean).join(' · ')
        : product.code;
      var fields = isScene
        ? '<div class="mcube-project-item__fields mcube-project-item__fields--scene"><label class="mcube-field"><span>Inspiration notes</span><textarea maxlength="600" placeholder="Design intent, mood, details or client feedback" data-mcube-project-field data-field="note" data-item-id="' + escapeHtml(item.id) + '">' + escapeHtml(item.note || '') + '</textarea></label></div>'
        : '<div class="mcube-project-item__fields"><label class="mcube-field"><span>Requirement</span><input type="text" maxlength="120" value="' + escapeHtml(item.requirement || '') + '" placeholder="e.g. 420 sq ft" data-mcube-project-field data-field="requirement" data-item-id="' + escapeHtml(item.id) + '"></label><label class="mcube-field"><span>Project notes</span><textarea maxlength="600" placeholder="Finish, room, sample or approval notes" data-mcube-project-field data-field="note" data-item-id="' + escapeHtml(item.id) + '">' + escapeHtml(item.note || '') + '</textarea></label></div>';
      return '<article class="mcube-project-item' + (isScene ? ' mcube-project-item--scene' : '') + (product.missing ? ' mcube-project-item--missing' : '') + '" data-project-item="' + escapeHtml(item.id) + '">' +
        '<a class="mcube-project-item__image" href="' + escapeHtml(product.url) + '" aria-label="View ' + escapeHtml(product.title) + '">' + image + '</a>' +
        '<div class="mcube-project-item__identity"><span class="mcube-technical-label">' + (isScene ? 'Inspiration reference' : 'Material reference') + '</span><h3 class="mcube-project-item__title"><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></h3>' + (identityMeta ? '<p class="mcube-project-item__code">' + escapeHtml(identityMeta) + '</p>' : '') + '</div>' +
        '<div class="mcube-project-item__controls"><label class="mcube-field"><span>Assign room</span><select class="mcube-project-item__move" data-mcube-project-item-move data-item-id="' + escapeHtml(item.id) + '"' + (hasDestinations ? '' : ' disabled') + '>' + options + '</select></label><button type="button" class="mcube-text-button mcube-text-button--danger mcube-project-item__remove" data-mcube-project-item-remove data-item-id="' + escapeHtml(item.id) + '">Remove</button></div>' +
        '<details class="mcube-project-item__details' + (detailLabels.length ? ' has-content' : '') + '"' + detailsOpen + '><summary class="mcube-project-item__details-toggle"><span>' + (isScene ? 'Reference Notes' : 'Details &amp; Notes') + '</span><span class="mcube-project-item__details-summary" data-mcube-details-summary>' + detailSummary + '</span><span class="mcube-project-item__details-icon" aria-hidden="true">+</span></summary><div class="mcube-project-item__details-body">' + fields + '<div class="mcube-project-item__field-status" data-mcube-save-status aria-live="polite"></div></div></details></article>';
    }

    renderProject(project) {
      var entries = projectItems(project);
      var counts = projectCounts(project);
      var countLabel = counts.materials + ' material' + (counts.materials === 1 ? '' : 's') + ' · ' + counts.scenes + ' inspiration' + (counts.scenes === 1 ? '' : 's');
      var shareLabel = counts.materials ? 'Request a Quote on WhatsApp' : 'Share Project on WhatsApp';
      var header = '<header class="mcube-project-detail__head"><div class="mcube-project-detail__copy"><a class="mcube-project-detail__back" href="' + escapeHtml(window.location.pathname) + '" data-mcube-action="dashboard">← All Projects</a><p class="mcube-kicker">Active project schedule</p><h1 class="mcube-project-detail__title">' + escapeHtml(project.name) + '</h1><p class="mcube-project-detail__meta">' + countLabel + ' · Updated ' + formatDate(project.updatedAt) + '</p></div><div class="mcube-project-detail__actions"><button type="button" class="btn btn--primary btn--outline" data-mcube-action="rename-current">Rename</button><button type="button" class="btn btn--primary btn--outline" data-mcube-action="share-current">' + shareLabel + '</button><button type="button" class="btn btn--primary btn--outline" data-mcube-action="delete-current">Delete</button><button type="button" class="btn btn--primary btn--solid" data-mcube-action="add-section">Add Room</button></div></header>';
      this.view.innerHTML = header + '<div data-mcube-project-sections-root><div class="mcube-loading-panel"><span class="mcube-loading-panel__mark" aria-hidden="true"></span><p>Arranging project items...</p></div></div>';
      var viewHeading = this.view.querySelector('.mcube-project-detail__title');
      if (viewHeading) {
        viewHeading.dataset.mcubeViewHeading = '';
        viewHeading.tabIndex = -1;
      }
      this.restorePendingFocus();
      Promise.all(entries.map(function (entry) { return resolveReference(itemReference(entry.item)); })).then(function (products) {
        if (this.currentProjectId() !== project.id) return;
        var productsByItem = {};
        entries.forEach(function (entry, index) { productsByItem[entry.item.id] = products[index]; });
        var unassigned = { id: '', name: 'Unassigned', items: project.unassignedItems || [] };
        var sections = [this.sectionMarkup(unassigned, project, productsByItem, true)].concat((project.sections || []).map(function (section) {
          return this.sectionMarkup(section, project, productsByItem, false);
        }, this));
        var sectionsRoot = this.view.querySelector('[data-mcube-project-sections-root]');
        if (sectionsRoot) sectionsRoot.innerHTML = '<div class="mcube-project-sections">' + sections.join('') + '</div>';
        this.syncDetailsVisibility();
        this.restorePendingFocus();
      }.bind(this));
    }

    render() {
      var store = projectStore();
      if (!store) return;
      this.statusElement.innerHTML = '';
      var projectId = this.currentProjectId();
      if (!projectId) {
        this.renderDashboard(store.getAll());
        return;
      }
      var project = store.get(projectId);
      if (!project) {
        this.view.innerHTML = '<div class="mcube-project-missing"><p class="mcube-kicker">Project unavailable</p><h1>This Project could not be found.</h1><p>It may have been removed in this browser or another open tab.</p><button type="button" class="btn btn--primary btn--solid" data-mcube-action="dashboard">Return to My Projects</button></div>';
        var missingHeading = this.view.querySelector('h1');
        if (missingHeading) {
          missingHeading.dataset.mcubeViewHeading = '';
          missingHeading.tabIndex = -1;
        }
        this.restorePendingFocus();
        return;
      }
      this.renderProject(project);
    }
  }

  class MCubeSceneProjectPicker extends HTMLElement {
    connectedCallback() {
      if (this.__mcubeReady) return;
      this.__mcubeReady = true;
      this.innerHTML = '<dialog class="mcube-dialog mcube-scene-project-dialog" data-mcube-scene-project-dialog aria-labelledby="mcube-scene-project-title">' +
        '<form method="dialog" class="mcube-dialog__surface" data-mcube-scene-project-form>' +
        '<div class="mcube-dialog__head"><div><p class="mcube-kicker">Visual reference</p><h2 id="mcube-scene-project-title">Add Inspiration to Project</h2></div><button type="button" class="mcube-icon-button" data-mcube-dialog-close aria-label="Close"><span aria-hidden="true">×</span></button></div>' +
        '<p data-mcube-scene-project-copy></p><fieldset class="mcube-project-picker" data-mcube-scene-project-options></fieldset>' +
        '<label class="mcube-field" data-mcube-scene-new-project-field hidden><span>New Project name</span><input type="text" name="scene_project_name" maxlength="80" autocomplete="off"></label>' +
        '<div class="mcube-dialog__actions"><button type="button" class="btn btn--primary btn--outline" data-mcube-dialog-close>Cancel</button><button type="submit" class="btn btn--primary btn--solid">Add to Project</button></div>' +
        '</form></dialog>';
      this.dialog = this.querySelector('[data-mcube-scene-project-dialog]');
      this.form = this.querySelector('[data-mcube-scene-project-form]');
      this.options = this.querySelector('[data-mcube-scene-project-options]');
      this.newField = this.querySelector('[data-mcube-scene-new-project-field]');
      this.copy = this.querySelector('[data-mcube-scene-project-copy]');
      this.form.addEventListener('change', this.handleChange.bind(this));
      this.form.addEventListener('submit', this.submit.bind(this));
      bindDialogClosers(this);
    }

    open(reference, trigger) {
      var store = projectStore();
      reference = core.createSceneReference(reference);
      if (!store || !reference) {
        globalNotice('Projects are still loading. Please try again.');
        return;
      }
      this.reference = reference;
      var projects = store.getAll();
      var firstAvailable = projects.find(function (project) { return !store.hasItem(project.id, reference); });
      var useNew = !firstAvailable;
      var rows = projects.map(function (project) {
        var exists = store.hasItem(project.id, reference);
        var counts = projectCounts(project);
        return '<label class="mcube-choice-row' + (exists ? ' is-disabled' : '') + '"><input type="radio" name="scene_project_choice" value="' + escapeHtml(project.id) + '"' + (exists ? ' disabled' : '') + (!useNew && firstAvailable.id === project.id ? ' checked' : '') + '><span><strong>' + escapeHtml(project.name) + '</strong><small>' + (exists ? 'Already contains this scene' : counts.materials + ' material' + (counts.materials === 1 ? '' : 's') + (counts.scenes ? ' · ' + counts.scenes + ' inspiration' + (counts.scenes === 1 ? '' : 's') : '')) + '</small></span></label>';
      });
      rows.push('<label class="mcube-choice-row"><input type="radio" name="scene_project_choice" value="__new__"' + (useNew ? ' checked' : '') + '><span><strong>Create a new Project</strong><small>Start a fresh design schedule.</small></span></label>');
      this.options.innerHTML = rows.join('');
      this.copy.textContent = 'Choose where to add “' + reference.title + '”. This will not add the scene to your Wishlist.';
      this.setNewProjectVisibility(useNew);
      this.newField.querySelector('input').value = '';
      showDialog(this.dialog, trigger);
    }

    setNewProjectVisibility(show) {
      var input = this.newField.querySelector('input');
      this.newField.hidden = !show;
      input.required = show;
    }

    handleChange(event) {
      if (!event.target.matches('input[name="scene_project_choice"]')) return;
      var useNew = event.target.value === '__new__';
      this.setNewProjectVisibility(useNew);
      if (useNew) this.newField.querySelector('input').focus();
    }

    submit(event) {
      event.preventDefault();
      var store = projectStore();
      var choice = this.form.querySelector('input[name="scene_project_choice"]:checked');
      if (!store || !choice || !this.reference) return;
      var projectId = choice.value;
      if (projectId === '__new__') {
        var nameInput = this.newField.querySelector('input');
        var name = nameInput.value.trim();
        if (!name) {
          nameInput.focus();
          return;
        }
        var project = store.create(name);
        projectId = project && project.id;
      }
      if (!projectId) return;
      var added = store.addItem(projectId, this.reference);
      closeDialog(this.dialog);
      globalNotice(added ? 'Inspiration scene added to the Project.' : 'This Project already contains the inspiration scene.');
    }
  }

  function openSceneProjectPicker(trigger) {
    var picker = document.querySelector('mcube-scene-project-picker');
    if (!picker) {
      picker = document.createElement('mcube-scene-project-picker');
      document.body.appendChild(picker);
    }
    picker.open(getReferenceFromElement(trigger), trigger);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mcube-scene-project]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openSceneProjectPicker(trigger);
  });

  window.MCubeWishlistProjects = {
    buildProjectMessage: buildProjectMessage,
    buildWishlistMessage: buildWishlistMessage,
    fetchProduct: fetchProduct,
    fetchProducts: fetchProducts,
    openWhatsApp: openWhatsApp
  };

  if (!customElements.get('mcube-wishlist-button')) customElements.define('mcube-wishlist-button', MCubeWishlistButton);
  if (!customElements.get('mcube-header-wishlist')) customElements.define('mcube-header-wishlist', MCubeHeaderWishlist);
  if (!customElements.get('mcube-wishlist-drawer')) customElements.define('mcube-wishlist-drawer', MCubeWishlistDrawer);
  if (!customElements.get('mcube-wishlist-page')) customElements.define('mcube-wishlist-page', MCubeWishlistPage);
  if (!customElements.get('mcube-project-manager')) customElements.define('mcube-project-manager', MCubeProjectManager);
  if (!customElements.get('mcube-scene-project-picker')) customElements.define('mcube-scene-project-picker', MCubeSceneProjectPicker);
})();
